<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>我的评论</span>
        <el-divider></el-divider>
      </p>
    </div>
    <div class="personal_comment_list_box"
    v-loading="listLoading"
    element-loading-text="列表加载中"
    element-loading-spinner="el-icon-loading">
      <div v-if="!listLoading && listData.length === 0" class="my_none">
        <img class="my_none_img" src="../../assets/img/user/commentListNone.png" alt="评论列表为空"><br/>
        <span class="my_none_user_text">暂无内容！</span>
      </div>
      <div v-else>
        <div v-for="(item) in listData" :key="item.id" class="personal_comment_list_item">
          <div class="personal_live_list_title" @click="jump(item.list_id, item.nav_id)">
            <a @click="jump(item.list_id, item.nav_id)">{{item.title}}</a>
          </div>
          <div v-if="item.reply_user_id === 0" class="personal_live_list_content">
            <span>{{user.name}}</span>:
            {{item.content}}
          </div>
          <div v-else class="personal_live_list_content">
            <img :src="user.portrait" alt="">
            <span>{{user.name}}</span> 回复 <span>{{item.user_name}}</span>:
            {{item.content}}
          </div>
          <div class="personal_live_list_time">
            {{item.time}}
          </div>
        </div>
        <el-pagination
          v-if="listData.length > 0"
          background
          layout="prev, pager, next"
          :page-size= "listLimit"
          :total="listNum"
          @current-change = "pageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      listData: [], // 文章列表
      listNum: 0, // 文章总条目
      listLimit: 10, // 列表当前页显示条目数
      listPage: 1, // 列表当前页码
      listLoading: true, // 开启加载动画
      user: {} // 当前登陆用户信息
    }
  },
  created () {
    this.pageChange()
    this.user = this.$store.state.user.info
  },
  methods: {
    // 获取数据
    pageChange: function (index) {
      const vueThat = this
      if (index === undefined) {
        vueThat.listPage = 1
      } else {
        vueThat.listPage = index
      }
      const data = {
        limit: vueThat.listLimit,
        page: vueThat.listPage
      }
      vueThat.myApi.getMyMesList(data).then(function (res) {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.listData = res.data.data.data
          vueThat.listNum = res.data.data.count
        }
      })
    },
    // 查看
    jump: function (id, navId) {
      this.mycommon.detailJump(this, id, navId)
    }
  }
}
</script>

<style scoped="scoped">
  .personal_live_list_box .personal_live_list_item .personal_live_list_head{
    margin-bottom: 0;
  }
</style>
